export const DEFAULT_SECTION_TITLE_COLOR = '#4338CA';

export function normalizeSectionTitleColor(color) {
    if (!color || typeof color !== 'string') {
        return DEFAULT_SECTION_TITLE_COLOR;
    }
    let hex = color.trim();
    if (hex.charAt(0) !== '#') {
        hex = '#' + hex;
    }
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
        return hex.toUpperCase();
    }
    if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
        return (
            '#' +
            hex.charAt(1) + hex.charAt(1) +
            hex.charAt(2) + hex.charAt(2) +
            hex.charAt(3) + hex.charAt(3)
        ).toUpperCase();
    }
    return DEFAULT_SECTION_TITLE_COLOR;
}

export function getSectionTitleColor(question) {
    if (!question) {
        return DEFAULT_SECTION_TITLE_COLOR;
    }
    return normalizeSectionTitleColor(question.section_title_color);
}

export const DEFAULT_SECTION_TITLE_BORDER_WIDTH = 2;
export const DEFAULT_SECTION_TITLE_BORDER_COLOR = '#E5E7EB';

export function normalizeSectionTitleBorderWidth(width) {
    if (width === 0 || width === '0') {
        return 0;
    }
    if (width === undefined || width === null || width === '') {
        return DEFAULT_SECTION_TITLE_BORDER_WIDTH;
    }
    const parsed = parseInt(String(width), 10);
    if (isNaN(parsed) || parsed < 0) {
        return DEFAULT_SECTION_TITLE_BORDER_WIDTH;
    }
    if (parsed > 20) {
        return 20;
    }
    return parsed;
}

export function normalizeSectionTitleBorderColor(color) {
    if (!color || typeof color !== 'string') {
        return DEFAULT_SECTION_TITLE_BORDER_COLOR;
    }
    let hex = color.trim();
    if (hex.charAt(0) !== '#') {
        hex = '#' + hex;
    }
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
        return hex.toUpperCase();
    }
    if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
        return (
            '#' +
            hex.charAt(1) + hex.charAt(1) +
            hex.charAt(2) + hex.charAt(2) +
            hex.charAt(3) + hex.charAt(3)
        ).toUpperCase();
    }
    return DEFAULT_SECTION_TITLE_BORDER_COLOR;
}

export function getSectionTitleBorderWidth(question) {
    if (!question) {
        return DEFAULT_SECTION_TITLE_BORDER_WIDTH;
    }
    return normalizeSectionTitleBorderWidth(question.section_title_border_width);
}

export function getSectionTitleBorderColor(question) {
    if (!question) {
        return DEFAULT_SECTION_TITLE_BORDER_COLOR;
    }
    return normalizeSectionTitleBorderColor(question.section_title_border_color);
}

export function isFirstSectionHeaderPosition(questions, index) {
    if (!questions || index < 0) {
        return true;
    }
    for (let i = 0; i < index; i++) {
        const q = questions[i];
        if (q && q.type !== 'page_break') {
            return false;
        }
    }
    return true;
}

export function isSectionHeaderAfterPageBreak(questions, index) {
    if (!questions || index <= 0) {
        return false;
    }
    const previous = questions[index - 1];
    return previous && previous.type === 'page_break';
}

export function getAutoSectionTitleBorderWidth(questions, index) {
    if (isFirstSectionHeaderPosition(questions, index)) {
        return 0;
    }
    if (isSectionHeaderAfterPageBreak(questions, index)) {
        return 0;
    }
    return DEFAULT_SECTION_TITLE_BORDER_WIDTH;
}

export function getSectionHeaderBorderStyle(question) {
    const width = getSectionTitleBorderWidth(question);
    if (width === 0) {
        return { borderTop: 'none' };
    }
    const color = getSectionTitleBorderColor(question);
    return {
        borderTopWidth: width + 'px',
        borderTopStyle: 'solid',
        borderTopColor: color,
    };
}

export const DEFAULT_PAGE_TITLE_COLOR = '#111827';

export function normalizePageTitleColor(color) {
    if (!color || typeof color !== 'string') {
        return DEFAULT_PAGE_TITLE_COLOR;
    }
    let hex = color.trim();
    if (hex.charAt(0) !== '#') {
        hex = '#' + hex;
    }
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
        return hex.toUpperCase();
    }
    if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
        return (
            '#' +
            hex.charAt(1) + hex.charAt(1) +
            hex.charAt(2) + hex.charAt(2) +
            hex.charAt(3) + hex.charAt(3)
        ).toUpperCase();
    }
    return DEFAULT_PAGE_TITLE_COLOR;
}

export function getPageTitleColor(question) {
    if (!question) {
        return DEFAULT_PAGE_TITLE_COLOR;
    }
    return normalizePageTitleColor(question.page_title_color);
}

export const DEFAULT_PAGE_TITLE_BORDER_WIDTH = 1;
export const DEFAULT_PAGE_TITLE_BORDER_COLOR = '#E5E7EB';

export function normalizePageTitleBorderWidth(width) {
    if (width === 0 || width === '0') {
        return 0;
    }
    if (width === undefined || width === null || width === '') {
        return DEFAULT_PAGE_TITLE_BORDER_WIDTH;
    }
    const parsed = parseInt(String(width), 10);
    if (isNaN(parsed) || parsed < 0) {
        return DEFAULT_PAGE_TITLE_BORDER_WIDTH;
    }
    if (parsed > 20) {
        return 20;
    }
    return parsed;
}

export function normalizePageTitleBorderColor(color) {
    if (!color || typeof color !== 'string') {
        return DEFAULT_PAGE_TITLE_BORDER_COLOR;
    }
    let hex = color.trim();
    if (hex.charAt(0) !== '#') {
        hex = '#' + hex;
    }
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
        return hex.toUpperCase();
    }
    if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
        return (
            '#' +
            hex.charAt(1) + hex.charAt(1) +
            hex.charAt(2) + hex.charAt(2) +
            hex.charAt(3) + hex.charAt(3)
        ).toUpperCase();
    }
    return DEFAULT_PAGE_TITLE_BORDER_COLOR;
}

export function getPageTitleBorderWidth(question) {
    if (!question) {
        return DEFAULT_PAGE_TITLE_BORDER_WIDTH;
    }
    return normalizePageTitleBorderWidth(question.page_title_border_width);
}

export function getPageTitleBorderColor(question) {
    if (!question) {
        return DEFAULT_PAGE_TITLE_BORDER_COLOR;
    }
    return normalizePageTitleBorderColor(question.page_title_border_color);
}
